<template>
	<EventCard
		v-bind="eventCardProps"
		:show-embed-payment-button="showEmbedPaymentButton"
		:show-embed-login-button="showEmbedLoginButton"
		:embed-login-link="loginUrl"
		:disable-embed-playback="forceLoginButton"
		:show-countdown="showCountdown"
		@init-embed-player="$emit('init-embed-player')"
	/>
</template>

<script>
import EventCard from '@shared/components/EventCard/EventCard';
import { EventCardProps } from '@shared/components/EventCard/EventCardProps';
import { mapGetters } from 'vuex';
import laroute from '@laroute';

export default {
	name:       'EventEmbedPreview',
	components: { EventCard },
	props:      {
		event: {
			type:    Object,
			default: () => {},
		},
		showInfos: {
			type:    Boolean,
			default: true,
		},
		showCountdown: {
			type:    Boolean,
			default: false,
		},
		forceLoginButton: {
			type:    Boolean,
			default: false,
		},
		forcePaymentButton: {
			type:    Boolean,
			default: false,
		},
	},
	computed: {
		...mapGetters({
			hasAccessToEvent:   'sharedUser/hasAccessToEvent',
			isPaymentProtected: 'event/isPaymentProtected',
			isLoggedIn:         'sharedUser/isLoggedIn',
		}),
		showEmbedPaymentButton() {
			return this.forcePaymentButton || (this.isPaymentProtected && !this.hasAccessToEvent(this.event));
		},
		showEmbedLoginButton() {
			const isLoginRestricted = this.event?.isLoginProtected || this.event?.arenaFeatureAccess?.isViewMediaContentRestricted;
			return this.forceLoginButton || (!this.showEmbedPaymentButton && isLoginRestricted && !this.isLoggedIn);
		},
		loginUrl() {
			const loginRoute = laroute.route('arena.login');
			return `${loginRoute}?redirectUrl=${encodeURIComponent(this.event.url)}`;
		},
		eventCardProps() {
			return EventCardProps(this.event, { isEmbed: true, showInfos: this.showInfos, hidePaymentRestriction: this.hasAccessToEvent(this.event) });
		},
	},
};
</script>
